import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/index';
import ModalBody from '../Modal/ModalBody';
import ModalFooter from '../Modal/ModalFooter';
import ModalHeader from '../Modal/ModalHeader';
import styles from '../Modal/styles.module.css';
import { trackEvent, CLICKED_NURTURE_BAR_POPUP } from '../../util/segment';
import { CONFIRM_EXIT_MODAL } from './nurture-content';


const NurtureModal = (props) => {
  const [showModal, setModal] = useState(true);

  const closeBtn = (btnContent) => {
    if (props.title === CONFIRM_EXIT_MODAL.title) {
      trackEvent(CLICKED_NURTURE_BAR_POPUP, {
        nurtureBarType: props.nurtureBarType,
        notificationType: '',
        message: btnContent,
        ctaType: 'close',
      });
    }
    props.unsetShowModalWithId();
    setModal(false);
  };

  return (
    <Modal
      namespace={props.namespace}
      width={props.width}
      showModal={showModal}
    >
      <ModalHeader closeBtn={() => { closeBtn('x'); }}>
        {
          props.index > 0 && (
            <div>
              Onboarding Goal #
              {props.index}
            </div>
          )
        }
        {props.title}
      </ModalHeader>
      <ModalBody>
        {props.body}
      </ModalBody>
      <ModalFooter>
        <div className={styles.trialModalFooter}>
          {
            props.btnCaption ? (
              <button
                type="button"
                onClick={closeBtn}
              >
                {props.btnCaption}
              </button>
            ) : (
              props.customFooter(closeBtn, props.exitNurtureBar)
            )
          }
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default NurtureModal;

NurtureModal.defaultProps = {
  btnCaption: '',
  exitNurtureBar: () => null,
  customFooter: () => null,
};

NurtureModal.propTypes = {
  index: PropTypes.number.isRequired,
  width: PropTypes.string.isRequired,
  namespace: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  btnCaption: PropTypes.string,
  unsetShowModalWithId: PropTypes.func.isRequired,
  exitNurtureBar: PropTypes.func,
  nurtureBarType: PropTypes.string.isRequired,
  customFooter: PropTypes.func,
};
